export default {
   getRowIndex: (target: HTMLElement): number => {
      const container = target.closest('tbody')
      const item = target.closest('.row') as HTMLElement
      const index = Array.prototype.indexOf.call(container?.children, item)
      return index
   }
}
